<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="绑定微信"
        :close-on-press-escape="false"
        width="750px"
        append-to-body>
        <p class="tac text-bold top-tip">重要消息微信通知，请及时绑定，以免造成不必要的损失！</p>
        <div class="img-wrap tac mt20 mb20">
            <img v-if="nodeEnv=='development'" class="img-wx" src="@/assets/img/bind-wx-test.png" alt="">
            <img v-else class="img-wx" src="@/assets/img/bind-wx.png" alt="">
        </div>
        <p class="tac" style="width: 70%;margin: 0 auto;">
            绑定说明：扫码后关注【万咖聚投】公众号，点击底部【绑定聚投2.0账号】，在打开的页面中输入账号与密码点击绑定，即可绑定成功。
        </p>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="primary" @click="dialogVisible = false" style="width:120px;">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "BindWX",
        data() {
            return {
                dialogVisible: false,
                nodeEnv:'',
            }
        },
        created(){
            this.nodeEnv = process.env.NODE_ENV;
        },
        methods: {
            showModal() {
                this.dialogVisible = true;
            },
        }
    }
</script>

<style lang="scss" scoped >
    .top-tip{
        margin-top: -20px;
    }
    .img-wx{
        width: 200px;
        height: 200px;
    }
</style>
